import { Route, Routes } from "react-router-dom";
import AllSquads from "../pages/dashboardPage/squadSettings/allSquads/AllSquads";
import SquadBanners from "../pages/dashboardPage/squadSettings/squadBanners/SquadBanners";

const SquadNavigator = () => {
  return (
    <Routes>
      <Route path="/show-all-squads" element={<AllSquads />} />
      <Route path="/control-squad-banners" element={<SquadBanners />} />
      <Route path="*" element={<AllSquads />} />
    </Routes>
  );
};

export default SquadNavigator;
